"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRepositoryMethods = void 0;
const repository_types_1 = require("../webapp/repository.types");
exports.userRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    deactivateMfa: {
        callMethod: 'POST',
        endpoint: '/user/deactivate-mfa',
    },
    setUserState: {
        callMethod: 'POST',
        endpoint: '/user/set-state',
    },
});
//# sourceMappingURL=user.methods.js.map